import React from 'react';

import { collectionLabels, changeTypes, } from '../shared/models/simulation';
import ProgressButton from './ProgressButton';

// 変更内容の見出しに使う。マスタ側の実体から人が読める値を拾う
const itemLabel = (change, mastersById) => {
  const master = mastersById[change.collectionName]?.[change.id];
  const values = change.values ?? {};
  return values.poNumber ?? values.number ?? master?.poNumber ?? master?.number ?? change.id;
};

export default function SimulationChangesTable ({ changes, mastersById, onRemove }) {
  if (changes.length === 0) {
    return <div className="text-muted">変更はありません。</div>;
  }
  return (
    <table className="table table-sm table-bordered">
      <thead className="thead-light">
        <tr>
          <th style={{ width: 90 }}>操作</th>
          <th style={{ width: 110 }}>対象</th>
          <th>項目</th>
          {onRemove && <th style={{ width: 70 }}></th>}
        </tr>
      </thead>
      <tbody>
        {
          changes.map((change) => {
            const type = changeTypes[change.type];
            return (
              <tr key={`${change.collectionName}/${change.id}`}>
                <td><span className={`badge badge-${type.color}`}>{type.label}</span></td>
                <td>{collectionLabels[change.collectionName]}</td>
                <td>{itemLabel(change, mastersById)}</td>
                {
                  onRemove && (
                    <td className="text-center">
                      <ProgressButton
                        size="sm"
                        color="link"
                        className="p-1"
                        title="この変更を取り消す"
                        process={_ => window.confirm('この変更を取り消しますか？') && onRemove(change.collectionName, change.id)}
                      >
                        <span className="fas fa-undo" />
                      </ProgressButton>
                    </td>
                  )
                }
              </tr>
            );
          })
        }
      </tbody>
    </table>
  );
};
